// @flow strict-local

import type {SchedulerTemplateWithExternals} from 'src/types/scheduler';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Container, BookingBody, BookingBox} from './common.jsx';
import {Button} from '@spaced-out/ui-lib/lib/button';
import useNoStoreApi from 'src/hooks/useNoStoreApi';

import {useIsMobile} from '../useIsMobile';

import {TimezonePicker} from 'src/components/scheduler/lib/timezone-picker/timezone-picker.jsx';

import TimezoneIcon from 'src/images/scheduler/timezone.svg';

import css from './timezone-picker.css';


export const SchedulerTimezonePicker = ({
  onChangeTimezone,
  agentId,
  templateSuffix,
}: {
  onChangeTimezone: (string) => mixed,
  agentId: string,
  templateSuffix: string,
}): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const suffix = [agentId, templateSuffix].filter(Boolean).join('/');
  const templateResource = useNoStoreApi<SchedulerTemplateWithExternals>(
    `scheduler/event-template/by-url-suffix/${suffix}`,
  );

  const [tz, setTz] = React.useState('');
  const isMobile = useIsMobile();

  if (templateResource.isLoading) {
    return null;
  }

  return (
    <Container brand={templateResource.result?.brand_settings}>
      <BookingBody className={isMobile ? css.mobileOnly : css.desktopOnly}>
        <BookingBox className={css.mainTzContent}>
          <div className={css.iconContainer}>
            <TimezoneIcon />
          </div>
          <h2>
            {`${t(
              'Sorry_we_couldn\'t_detect_your_time_zone',
              'Sorry we couldn\'t detect your time zone',
            )}.`}
            <br />
            {` ${t(
              'Please_select_your_time_zone_to_continue',
              'Please select your time zone to continue',
            )}.`}
          </h2>
          <div className={css.tzField}>
            <p className={css.tzFieldLabel}>
              {t('Select_a_timezone', 'Select a timezone')}
            </p>
            <TimezonePicker value={tz} onChange={(val) => setTz(val)} />
          </div>
          <div>
            <Button
              onClick={(evt) => {
                evt.preventDefault();

                onChangeTimezone(tz);
              }}
            >
              {t('Next', 'Next')}
            </Button>
          </div>
        </BookingBox>
      </BookingBody>
    </Container>
  );
};
